<template>
  <zm-drawer
    ref="drawer"
    @ok="handleSubmit"
    :title="title"
    :width="760"
    :visible="visible"
    @cancel="open(false)"
  >
    <div slot="drawerBody">
      <a-form :form="form">
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
              <a-input
                placeholder="请输入姓名"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['userName', { rules: [{ required: true, message: '请输入姓名！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="性别">
              <a-select
                :allowClear="true"
                placeholder="请选择性别"
                :disabled="!isEdit"
                v-decorator="['gender', { rules: [{ required: true, message: '请选择性别！' }] }]"
              >
                <a-select-option v-for="(option, index) in genderList" :key="index" :value="option.value">
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应聘岗位">
              <a-select
                :allowClear="true"
                placeholder="请选择应聘岗位"
                :disabled="!isEdit"
                v-decorator="['departmentJob', { rules: [{ required: true, message: '请选择应聘岗位！' }] }]"
              >
                <a-select-option v-for="(option, index) in jobList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属部门">
              <a-tree-select
                show-search
                :filterTreeNode="filterTreeNode"
                style="width: 100%"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                placeholder="请选择所属部门"
                allow-clear
                tree-default-expand-all
                :disabled="!isEdit"
                :treeData="deptList"
                @change="changeDept"
                v-decorator="['applyDepartment', { rules: [{ required: true, message: '请选择所属部门！' }] }]"
              ></a-tree-select>
              <!-- <a-select
                :allowClear="true"
                placeholder="请选择所属部门"
                :disabled="!isEdit"
                v-decorator="['applyDepartment', { rules: [{ required: true, message: '请选择所属部门！' }] }]"
              >
                <a-select-option v-for="(option, index) in deptList" :key="index" :value="option.value">
                  {{ option.label }}
                </a-select-option>
              </a-select> -->
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实习岗">
              <a-switch
                style="margin: 2px 8px 6px 0"
                size="small"
                :disabled="!isEdit"
                :checked="form.getFieldValue('internship')"
                v-decorator="['internship', { rules: [{ required: true, message: '请选择是否是实习岗！' }] }]"
              />
              <span>{{ form.getFieldValue('internship') ? '是' : '否' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="在职状态">
              <a-select
                :allowClear="true"
                placeholder="请选择在职状态"
                :disabled="!isEdit"
                v-decorator="['workStatus', { rules: [{ required: false }] }]"
              >
                <a-select-option v-for="(option, index) in workStatusList" :key="index" :value="option.value">
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最高学历">
              <a-select
                :allowClear="true"
                placeholder="请选择最高学历"
                :disabled="!isEdit"
                v-decorator="['education', { rules: [{ required: false }] }]"
              >
                <a-select-option v-for="(option, index) in educationList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="毕业院校">
              <a-input
                placeholder="请输入毕业院校"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['school', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电子邮箱">
              <a-input
                placeholder="请输入电子邮箱"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['email', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码">
              <a-input
                placeholder="请输入手机号码"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['tel', { rules: [{ required: true, message: '请输入手机号码！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="目前年薪">
              <a-input
                style="width: calc(100% - 20px)"
                placeholder="请输入目前年薪"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['currentAnnualSalary', { rules: [{ required: false }] }]"
              />
              <span style="display:inline-block;width:20px;text-align:right;">元</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="期望年限">
              <a-input
                style="width: calc(100% - 20px)"
                placeholder="请输入期望年限"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['itemAnnualSalary', { rules: [{ required: false }] }]"
              />
              <span style="display:inline-block;width:20px;text-align:right;">元</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="邀约平台">
              <a-select
                :allowClear="true"
                placeholder="请选择邀约平台"
                :disabled="!isEdit"
                v-decorator="['invitePlatform', { rules: [{ required: false }] }]"
              >
                <a-select-option v-for="(option, index) in platformList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="面试时间">
              <a-date-picker
                show-time
                format="YYYY-MM-DD HH:mm"
                :disabled="!isEdit"
                style="width: 100%"
                placeholder="请选择面试时间"
                v-decorator="['planInterviewTime', { rules: [{ required: true, message: '请选择面试时间！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="面试官">
              <a-select
                :allowClear="true"
                placeholder="请选择面试官"
                :disabled="!isEdit"
                v-decorator="['interviewer', { rules: [{ required: true, message: '请选择面试官！' }] }]"
              >
                <a-select-option v-for="(option, index) in userList" :key="index" :value="option.id">
                  {{ option.userName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="简历附件" required>
              <zm-upload
                ref="uploader"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="fileList"
                acceptType="txt,doc,docx,xls,xlsx,pdf,ppt,pptx,jpeg,jpg,png"
                @handleUpload="handleUpload"
              ></zm-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-drawer>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { insertApplicant, updateApplicant } from '@/api/applicant'
import { getSysDeptList, getUserBaseInfo } from '@/api/baseInfo'
import { formateTreeSelectData } from '@/utils/util'
import { getDictInfoByCode } from '@/api/dict'
export default {
  name: 'editApplicant',
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    // drawerWidth () {
    //   const width = window.innerWidth - 200
    //   return width
    // },
    ...mapGetters(['jobList']),
  },
  data () {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'applicant' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 },
      },
      colSpan: 12,

      genderList: [
        { label: '男', value: 1 },
        { label: '女', value: 2 },
      ],
      deptList: [],
      internshipList: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      workStatusList: [
        { label: '待业', value: 1 },
        { label: '在职', value: 2 },
      ],
      educationList: [],
      platformList: [],
      userList: [],

      headers: {
        Authorization: this.$store.state.user.token
      },
      fileList: []
    }
  },
  methods: {
    initDictData () {
      // 获取部门树
      getSysDeptList({ id: 0 }).then(res => {
        if (res.status === 0) {
          const data = { children: res.data, name: '部门' }
          const formateModel = formateTreeSelectData(data, 'name', 'id')
          this.deptList = formateModel.children
        }
      })
      // 获取学历
      getDictInfoByCode({ pCode: 'education' }).then(res => {
        if (res.status === 0) {
          this.educationList = res.data
        }
      })
      // 获取邀约平台
      getDictInfoByCode({ pCode: 'PLATFORM_APPLICATION' }).then(res => {
        if (res.status === 0) {
          this.platformList = res.data
        }
      })
      // 获取面试官
      getUserBaseInfo({ status: 1, paging: false }).then(res => {
        if (res.status === 0) {
          this.userList = res.data
        }
      })
    },
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        this.initDictData()
        if (this.type === this.$sysInfo.MODAL_ADD) {
          this.$nextTick(() => {
            this.form.setFieldsValue({ internship: false })
          })
        }
        if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
          this.getModelInfo(this.model)
        }
      } else {
        this.model = {}
      }
    },
    getModelInfo () {
      this.$nextTick(() => {
        console.log('internship', !!this.model.internship)
        this.form.setFieldsValue({
          userName: this.model.userName,
          gender: this.model.gender,
          departmentJob: this.model.departmentJob,
          applyDepartment: this.model.applyDepartment,
          internship: !!this.model.internship,
          workStatus: this.model.workStatus,
          education: this.model.education,
          school: this.model.school,
          email: this.model.email,
          tel: this.model.tel,
          currentAnnualSalary: this.model.currentAnnualSalary,
          itemAnnualSalary: this.model.itemAnnualSalary,
          invitePlatform: this.model.invitePlatform,
          planInterviewTime: moment(this.model.planInterviewTime, 'YYYY-MM-DD'),
          interviewer: this.model.interviewer
        })

        this.fileList = this.model.fileList
      })
    },
    // 提交表单
    handleSubmit () {
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...value }
          params.phone = params.tel
          params.internship = params.internship ? 1 : 0
          params.planInterviewTime = moment(params.planInterviewTime).format('YYYY-MM-DD HH:mm')
          params.fileList = this.fileList
          this.$refs.drawer.handleOkLoading(true)
          if (this.type === this.$sysInfo.MODAL_ADD) {
            const res = await insertApplicant(params).catch((error) => {
              this.$refs.drawer.handleOkLoading(false)
              console.log('更新失败', error)
              this.$message.error('更新失败，请稍后重试！')
            })
            this.$refs.drawer.handleOkLoading(false)
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            params.id = this.model.id
            const res = await updateApplicant(params).catch((error) => {
              this.$refs.drawer.handleOkLoading(false)
              console.log('更新失败', error)
              this.$message.error('更新失败，请稍后重试！')
            })
            this.$refs.drawer.handleOkLoading(false)
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          }
        }
      })
    },
    // 清空表单
    formClear () {
      this.$nextTick(() => {
        this.form.resetFields()
        this.fileList = []
        this.$refs.uploader.clearFileList()
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    handleUpload (fileList) {
      this.fileList = fileList
    },

    // 部门选择
    changeDept (value, label) {
      this.model.applyDepartmentName = label[0] || ''
    },
    filterTreeNode (inputValue, treeNode) {
      return treeNode.componentOptions.propsData.dataRef.name.indexOf(inputValue.toLowerCase()) > -1
    }
  }
}
</script>

<style scoped lang="less">
</style>

